
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.679","height":"26.687"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 222","transform":"translate(2.121 1.5)","fill":"none","stroke":"#fff","stroke-miterlimit":"10","stroke-width":"3"}},[_c('circle',{attrs:{"data-name":"Ellipse 22","cx":"9.767","cy":"9.767","r":"9.767","transform":"translate(3.524)"}}),_c('path',{attrs:{"data-name":"Line 26","stroke-linecap":"round","d":"M0 23.065l6.386-6.386"}})])])
          )
        }
      }
    